module.exports = __webpack_public_path__ + "static/media/Beechwood-By-Laws.44123d42.pdf";